import CONSTANTS from "@/common/constants";

const signupRoutes = [
  {
    path: "/signup",
    name: CONSTANTS.ROUTE.NAME.SiGNUP,
    component: () => import("@/views/SignUp/SignUp.vue"),
    meta: {
      layout: "NO_HEADER",
    },
  },
];

export default signupRoutes;
